import script from "./GeneralControlData.vue?vue&type=script&lang=ts&setup=true&name=memberList"
export * from "./GeneralControlData.vue?vue&type=script&lang=ts&setup=true&name=memberList"

import "./GeneralControlData.vue?vue&type=style&index=0&id=763c50fb&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-763c50fb"]])

export default __exports__